import { useEffect, useMemo } from 'react';
import { applyHead } from '@/lib/head';

/**
 * Declarative <head> tags (title, meta, JSON-LD). Renders nothing and removes
 * its tags again on unmount or when the values change.
 */
export default function Head({ title, meta = [], jsonLd }) {
  const key = JSON.stringify([title, meta, jsonLd]);
  const spec = useMemo(() => ({ title, meta, jsonLd }), [key]);

  useEffect(() => applyHead(spec), [spec]);

  return null;
}